import { ArticleWrapper } from '../../styles';

export const ArticleParagraph = ({
  markdown,
}: {
  markdown: string;
}): JSX.Element => {
  return (
    <ArticleWrapper>
      <div dangerouslySetInnerHTML={{ __html: markdown as string }} />
    </ArticleWrapper>
  );
};
